/**
 * Meta Pixel tracking helper
 * Pixel ID: 3522705387890367
 * PageView is fired globally via index.html
 */

function track(event, params = {}) {
  if (typeof window.fbq === "function") {
    window.fbq("track", event, params);
  }
}

export const pixel = {
  /** User initiates Stripe checkout */
  initiateCheckout: ({ price, currency = "EUR", messageId }) =>
    track("InitiateCheckout", { value: price, currency, content_ids: [messageId], content_type: "product" }),

  /** Stripe payment confirmed */
  purchase: ({ price, currency = "EUR", messageId }) =>
    track("Purchase", { value: price, currency, content_ids: [messageId], content_type: "product" }),

  /** Recipient opens a BIZOU */
  viewContent: ({ messageId, title }) =>
    track("ViewContent", { content_ids: [messageId], content_name: title || "BIZOU" }),
};
